module.exports = __webpack_public_path__ + "static/media/empty.43480068.jpg";